import { __assign, __read } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import TextField from '@mui/material/TextField';
import Color from '../../Style/Color';
import Font from '../../Style/Font';
import { useState } from 'react';
var StyledComponent = styled(function (props) {
    var _a = __read(useState(props === null || props === void 0 ? void 0 : props.value), 2), value = _a[0], setValue = _a[1];
    return (_jsx("div", { id: props.id, "data-current-value": value, children: _jsx(TextField, { id: props === null || props === void 0 ? void 0 : props.id, autoFocus: props === null || props === void 0 ? void 0 : props.autoFocus, type: props === null || props === void 0 ? void 0 : props.type, onChange: function (e) {
                setValue(e.target.value);
                if (props === null || props === void 0 ? void 0 : props.onChange) {
                    props === null || props === void 0 ? void 0 : props.onChange(e);
                }
            }, defaultValue: props === null || props === void 0 ? void 0 : props.defaultValue, error: props === null || props === void 0 ? void 0 : props.error, disabled: props === null || props === void 0 ? void 0 : props.disabled, value: props === null || props === void 0 ? void 0 : props.value, sx: {
                width: (props === null || props === void 0 ? void 0 : props.width) || "auto",
                height: (props === null || props === void 0 ? void 0 : props.height) || "auto",
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        border: "1px solid ".concat(Color.component.gray),
                    },
                    "&:hover fieldset": {
                        border: "1px solid ".concat(Color.component.gray_02),
                    },
                    "&.Mui-focused fieldset": {
                        border: "1px solid ".concat(Color.component.gray_dark),
                    },
                },
                "& .MuiInputBase-input": {
                    padding: 0,
                },
                borderRadius: "0.25rem",
                background: Color.primary.white,
            }, InputProps: {
                // input component의 스타일 변경
                sx: __assign(__assign({ width: (props === null || props === void 0 ? void 0 : props.width) || "auto" }, ((props === null || props === void 0 ? void 0 : props.multiline) ? { height: "auto" } : { height: "1.75rem" })), { padding: "0.375rem 0.375rem 0.375rem 0.625rem", alignItems: "center", flexShrink: 0, 
                    //text
                    color: Color.text.secondary, fontFeatureSettings: Font.fontFeatureSettings }),
                inputProps: {
                    style: {
                        textAlign: props === null || props === void 0 ? void 0 : props.textAlign,
                    },
                },
            }, placeholder: props === null || props === void 0 ? void 0 : props.placeholder, multiline: props === null || props === void 0 ? void 0 : props.multiline, rows: props === null || props === void 0 ? void 0 : props.rows, maxRows: props === null || props === void 0 ? void 0 : props.maxRows }) }));
})(function () { return ({
    display: "flex",
    fullWidth: true,
}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
